import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import EnabledDisabledPopUp from "../../components/popups/EnabledDisabledPopUp";
import { fieldForceEnableDisable } from "../../redux/actions/fieldForceAction";
import "../products/product.css";
import ErrorPopup from "../../components/popups/ErrorPopup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const FFTableData = ({ data, index, currentPage, fetchFieldForceUser }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    dispatch(
      fieldForceEnableDisable(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const onEnableDisableSuccess = (data) => {
    setOnEnableShow(false);
    setEnabledDisable(true);

    const timeOutFnc = () => {
      setEnabledDisable(false);
      fetchFieldForceUser();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  function add3Dots(string, limit) {
    let dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

  const renderHqTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {data?.fieldForceUserHeadQuaters?.map((ele, index) => (
        <span key={index}>
          {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
          {ele?.headQuater?.name ? ele?.headQuater?.name : "--"}
        </span>
      ))}
    </Tooltip>
  );

  const renderDivTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {data?.fieldForceDivisions?.map((ele, index) => (
        <span key={index}>
          {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
          {ele?.vendorDivision?.name ? ele?.vendorDivision?.name : "--"}
        </span>
      ))}
    </Tooltip>
  );

  return (
    <tr className="table-rows1 text-nowrap" key={index}>
      <td className="table-each-row-data  ">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">
        {data?.user_id ? data?.user_id : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data?.code ? data?.code : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data?.employee_id}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data?.name ? data?.name : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data?.fieldForceDesignation?.name
          ? data?.fieldForceDesignation?.name
          : "--"}
      </td>
      <td className="table-each-row-data  text-center text-capitalize">
        {data?.fieldForceDesignation?.approval_level
          ? data?.fieldForceDesignation?.approval_level
          : "--"}
      </td>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={renderHqTooltip}
      >
        <td
          className="table-each-row-data text-truncate"
          style={{ maxWidth: "200px" }}
        >
          {data.fieldForceUserHeadQuaters?.length > 0
            ? data.fieldForceUserHeadQuaters?.map((ele, index) => {
                return (
                  <span className="slice-word" key={index}>
                    <span style={{ color: "#B0B3C7" }}>
                      {index ? " | " : ""}
                    </span>
                    {ele?.headQuater?.name ? ele?.headQuater?.name : "--"}
                  </span>
                );
              })
            : "--"}
        </td>
      </OverlayTrigger>
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={renderDivTooltip}
      >
        <td
          className="table-each-row-data text-truncate"
          style={{ maxWidth: "200px" }}
        >
          {data.fieldForceDivisions?.length > 0
            ? data.fieldForceDivisions?.map((ele, index) => {
                return (
                  <span className="slice-word" key={index}>
                    <span style={{ color: "#B0B3C7" }}>
                      {index ? " | " : ""}
                    </span>
                    {ele?.vendorDivision?.name
                      ? ele?.vendorDivision?.name
                      : "--"}
                  </span>
                );
              })
            : data?.vendorDivision?.name
            ? data?.vendorDivision?.name
            : "--"}
        </td>
      </OverlayTrigger>
      {data.status ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}

      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/field-force/user/view/${data.id}`)}
          >
            {"view"}
          </button>
          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() => navigate(`/field-force/user/edit/${data.id}`)}
              >
                {"edit"}
              </button>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className={data.status ? `button-disable` : `button-enable`}
                type="button"
                color={"green"}
                onClick={() => setOnEnableShow(true)}
              >
                {data.status ? "disable" : "enable"}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <EnableDisableModal
        enableDisableFunc={enableDisableFunc}
        title={`Employee - ${data?.user_id} ?`}
        handleClose={() => setOnEnableShow(false)}
        id={data.id}
        status={data.status}
        show={onEnableShow}
        consumerText={false}
      />
      <EnabledDisabledPopUp
        title={`Employee - ${data?.user_id}`}
        show={enabledDisable}
        status={data.status}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </tr>
  );
};
export default FFTableData;
